export const NEW_DESIGN_SUFFIX = `?runtimeOverrides={"newAdminDesign":"true"}`;
